import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { StandTransformationHistoryDetailDto } from '../../proxy/geographic/dtos/stand-transformation-history-detail';

@Component({
  selector: 'app-stand-transformation-history-detail-aside',
  standalone: true,
  imports: [CommonModule, LocalizationPipe],
  templateUrl: './stand-transformation-history-detail-aside.html',
  styleUrl: './stand-transformation-history-detail-aside.scss',
})
export class StandTransformationHistoryDetailAsideComponent {
  readonly loading = input(false);
  readonly details = input<StandTransformationHistoryDetailDto[]>([]);

  readonly initialDetails = computed(() => this.details().filter(item => !item.isFinal));
  readonly finalDetails = computed(() => this.details().filter(item => !!item.isFinal));

  getStandName(item: StandTransformationHistoryDetailDto): string {
    return item.standName?.trim() || '-';
  }
}
